import router from '../router/index'
import {Message} from 'element-ui'
import * as baseMethods from '../utils/baseMethod'
import {emailCode, smsSend} from '../services/api.index'
// 判断是否为空
export const isEmpty = (str) => {
  if (str === null || str === undefined || str === '') {
    return true
  }
  return false
}
//获取字符串中包含某个字符个数
export const getCharCount=(str,char)=>{
  let count= 0;
  for(let i=0;i<str.length;i++){
    if(str[i]==char){
      count++
    }
  }
  return count;
}
// 获取本地存储方法
export const getLocalObj = (n, auth = false) => {
  if(window.localStorage[n] && typeof window.localStorage[n] !== 'undefined' && window.localStorage[n] !== 'undefined') {
    return JSON.parse(window.localStorage[n])
  }else{
    if(auth) {
      window.location = decodeURIComponent(process.env.SHOP_URL + "member/login?redirectUrlTs=" + router.currentRoute.fullPath)
    }else{
      return ''
    }
  }
}

// 设置本地存储
export const setLocalObj = (n, o) => {
  window.localStorage[n] = (typeof o === 'object') ? JSON.stringify(o) : o
}

// 获取本地存储方法 字符串
export const getLocalStr = (n) => {
  return (window.localStorage[n] && typeof window.localStorage[n] !== 'undefined' && window.localStorage[n] !== 'undefined') ? window.localStorage[n] : ''
}

// 设置本地存储
export const setLocalStr = (n, o) => {
  window.localStorage[n] =  o
}
// 延迟2s页面跳转
export const hrefUrl = (path) => {
  setTimeout(() => {
    router.push(path)
  }, 2000)
}

// 格式化时间
export const formatDate = (date) => {
  let year = new Date(date).getFullYear()
  let month = (new Date(date).getMonth() + 1).toString().padStart(2, '0')
  let day = new Date(date).getDate().toString().padStart(2, '0')
  return [year, month, day]
}

// 请求响应头获取总数
export const getTotal = (res) => {
  return Number(res.headers['x-total-count'])
}

// 手机号格式验证
export const checkPhone = (phone) => {
  if (!(/^1[3456789]\d{9}$/.test(phone))) {
    return false
  }
  return true
}

// 邮箱格式验证
export const checkEmail = (email) => {
  const emailReg = /^([a-zA-Z0-9]+[_|\-|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
  if (!(emailReg.test(email))) {
    return false
  }
  return true
}

// 密码格式验证
export const checkPassword = (password) => {
  if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(password))) {
    return false
  }
  return true
}

// element 手机号验证
export const checkPhoneRules = (value, callback) => {
  if (value === '') {
    callback(new Error('请输入手机号'))
  } else if (!checkPhone(value)) {
    callback(new Error('手机号码格式不正确'))
  } else {
    callback()
  }
}

// element 邮箱验证
export const checkEmailRules = (value, callback) => {
  if (value === '') {
    callback(new Error('请输入邮箱'))
  } else if (!checkEmail(value)) {
    callback(new Error('邮箱格式不正确'))
  } else {
    callback()
  }
}
// 密码格式验证
export const checkPasswordRules = (value, callback, name) => {
  if (value === '') {
    if (name === 'password') {
      callback(new Error('请输入密码'))
    } else {
      callback(new Error('请输入确认密码'))
    }
  } else if (!checkPassword(value)) {
    callback(new Error('密码格式不正确'))
  } else {
    callback()
  }
}

// 发送验证码
export const sendCode = (phone, form, that) => {
  let errPhoneMsg
  that.$refs[form].validateField('phone', errMsg => {
    if (errMsg) {
      errPhoneMsg = errMsg
    }
  })
  if (errPhoneMsg) return
  that.timesCount = 60
  let timer = setInterval(() => {
    if (that.timesCount > 0) {
      that.timesCount--
    } else {
      clearInterval(timer)
    }
  }, 1000)
  smsSend(phone).then(() => {
    Message.success('发送成功')
  })
}

// 发送邮箱验证码
export const sendEmailCode = (email, form, that) => {
  let errPhoneMsg
  that.$refs[form].validateField('email', errMsg => {
    if (errMsg) {
      errPhoneMsg = errMsg
    }
  })
  if (errPhoneMsg) return
  that.timesCount = 60
  let timer = setInterval(() => {
    if (that.timesCount > 0) {
      that.timesCount--
    } else {
      clearInterval(timer)
    }
  }, 1000)
  emailCode(email).then(() => {
    Message.success('发送成功')
  })
}

// 获取地址
export const getAddressByMember = (memberInfo) => {
  console.info(memberInfo)
  const deliveryAddress = memberInfo.deliveryAddress
  return {
    provinceName: deliveryAddress.province,
    cityName: deliveryAddress.city,
    areaName: deliveryAddress.county,
    provinceCode: deliveryAddress.provinceCode,
    cityCode: deliveryAddress.cityCode,
    areaCode: deliveryAddress.countyCode,
    streetAddress: deliveryAddress.detail,
    contactName: memberInfo.realName,
    mobileNumber: memberInfo.mobile
  }
}
export const getAddress = () => {
  const memberInfo = getLocalObj('memberInfo')
  const deliveryAddress = memberInfo.deliveryAddress
  let address = {
    provinceName: deliveryAddress.province,
    cityName: deliveryAddress.city,
    areaName: deliveryAddress.county,
    provinceCode: deliveryAddress.provinceCode,
    cityCode: deliveryAddress.cityCode,
    areaCode: deliveryAddress.countyCode,
    streetAddress: deliveryAddress.detail,
    contactName: memberInfo.realName,
    mobileNumber: memberInfo.mobile
  }
  return address
}

export const getRaAddress = () => {
  const memberInfo = getLocalObj('memberInfo')
  const deliveryAddress = memberInfo.deliveryAddress
  console.log(deliveryAddress)
  let address = {
    raProvince: deliveryAddress.province,
    raCity: deliveryAddress.city,
    raProvinceCode: deliveryAddress.provinceCode,
    raCityCode: deliveryAddress.cityCode,
    raAddress: deliveryAddress.detail,
    raCounty: deliveryAddress.county,
    raCountyCode: deliveryAddress.countyCode,
  }
  return address
}

// 轮播图跳转
export const carouselsAction = (res) => {
  const content = res.clickTriggerContent
  switch (res.clickTriggerAction) {
    case 'OPEN_URL':
      window.location.href = content
      break
    case 'MARKETING_CONTENT':
      router.push(`/market?id=${content}`)
      break
    case 'NEWS_INFORMATION':
      router.push(`/news/details/${content}`)
      break
    case 'MOLECULAR_PRODUCT':
      router.push(`/products/details/${content}`)
      break
  }
}

// 图片下载
export const downloadImage = (imgsrc, name) => { // 下载图片地址和图片名
  var image = new Image()
  // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous')
  image.onload = function() {
    var canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    var context = canvas.getContext('2d')
    context.drawImage(image, 0, 0, image.width, image.height)
    var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据

    var a = document.createElement('a') // 生成一个a元素
    var event = new MouseEvent('click') // 创建一个单击事件
    a.download = name || 'tsingke' // 设置图片名称
    a.href = url // 将生成的URL设置为a.href属性
    a.dispatchEvent(event) // 触发a的单击事件
  }
  image.src = imgsrc
}

// 文件下载
export const downloadFile = (res, name, type) => {
  let blob
  if (type === 'doc') {
    blob = new Blob([res], {type: 'application/octet-stream'})
  } else {
    blob = new Blob([res], {type: 'application/vnd.ms-excel'})
  }
  let downloadElement = document.createElement('a')
  let href = window.URL.createObjectURL(blob) // 创建下载的链接
  downloadElement.href = href
  if (type === 'doc') {
    downloadElement.download = `${name}.rar` // 下载后文件名
  } else {
    downloadElement.download = `${name}.xls` // 下载后文件名
  }
  document.body.appendChild(downloadElement)
  downloadElement.click() // 点击下载
  document.body.removeChild(downloadElement) // 下载完成移除元素
  window.URL.revokeObjectURL(href) // 释放掉blob对象
}

// 分子订单状态
export const molecularOrderStatus = (status) => {
  let statusName = ''
  switch (status) {
    case 'CANCEL':
      statusName = '订单取消'
      break
    case 'NEED_CONFIRM':
      statusName = '待提交'
      break
    case 'NEED_AUDITING':
      statusName = '待审核'
      break
    case 'NEED_SEND':
      statusName = '未发货'
      break
    case 'PART_SEND':
      statusName = '部分发货'
      break
    case 'FINISHED':
      statusName = '全部发货'
      break
  }
  return statusName
}

// 订单状态
export const orderStatus = (status) => {
  let statusName = ''
  switch (status) {
    case 'WAIT':
      statusName = '待提交'
      break
    case 'NOT_STARTED':
      statusName = '未开始'
      break
    case 'ING':
      statusName = '进行中'
      break
    case 'CANCEL':
      statusName = '订单取消'
      break
    case 'OK':
      statusName = '已完成'
      break
  }
  return statusName
}

// 结算状态
export const settlementStatus = (status) => {
  let statusName = ''
  switch (status) {
    case 'NOT_INVOICED':
    case 'INVOICED':
      statusName = '未结算'
      break
    case 'PAYED':
      statusName = '已结算'
      break
  }
  return statusName
}

// 基因结算状态
export const settlementGeneStatus = (status) => {
  let statusName = ''
  switch (status) {
    case 'NOT_INVOICED':
    case 'INVOICED':
      statusName = '未结算'
      break
    case 'PART_INVOICED':
      statusName = '部分结算'
      break
    case 'PAYED':
      statusName = '全部结算'
      break
  }
  return statusName
}

// 发货状态
export const shippedStatus = (status) => {
  let statusName = ''
  switch (status) {
    case 'NO':
      statusName = '未配送'
      break
    case 'PART':
      statusName = '部分配送'
      break
    case 'OK':
      statusName = '全部配送'
      break
  }
  return statusName
}
// 基因配送状态
export const shippedGeneStatus = (status) => {
  if (!status) return '-'
  let statusName = ''
  switch (status) {
    case 'NO':
      statusName = '未配送'
      break
    case 'PART':
      statusName = '配送中'
      break
    case 'OK':
      statusName = '已完成'
      break
    case 'NEED_SEND':
      statusName = '未配送'
      break
    case 'SENDING':
      statusName = '配送中'
      break
    case 'FINISHED':
      statusName = '已完成'
      break
  }
  return statusName
}

// 工单状态
export const workOrderStatus = (status) => {
  let statusName = ''
  switch (status) {
    case 'ING':
      statusName = '进行中'
      break
    case 'PAUSE':
      statusName = '暂停'
      break
    case 'CLOSE':
      statusName = '关闭'
      break
    case 'OK':
      statusName = '完成'
      break
  }
  return statusName
}

// 反应状态
export const reactionStatus = (status) => {
  let statusName = ''
  switch (status) {
    case 'ING':
      statusName = '实验中'
      break
    case 'PAUSE':
      statusName = '暂停'
      break
    case 'CLOSE':
      statusName = '关闭'
      break
    case 'S':
      statusName = '成功'
      break
    case 'F':
      statusName = '失败'
      break
  }
  return statusName
}

// 反应类型
export const reactionType = (type) => {
  let typeName = ''
  switch (type) {
    case 'GENERAL':
      typeName = '常规'
      break
    case 'TRY':
      typeName = '试做'
      break
  }
  return typeName
}


export const appraisalStatus1 = (status) => {
  let item = pro.appraisalStatus.find(
    (v) => v.value === status
  );
  return item ? item.label : "";
}
export const appraisalStatus3 = (status) => {
  let item = prt.appraisalStatus.find(
    (v) => v.value === status
  );
  return item ? item.label : "";
}
export const pro = {
  appraisalStatus: [
    {
      label: '正常',
      value: "ZC"
    },
    {
      label: '浓度低，最大量测序',
      value: "ZCM"
    },
    {
      label: '暂不测序',
      value: "ZT1"
    },
    {
      label: '暂不测序,片段大小不符',
      value: "ZT2"
    },
    {
      label: '暂不测序,空载体',
      value: "ZT3"
    },
    {
      label: '重新纯化模板，暂不测序',
      value: "ZT4"
    },
    {
      label: '重新定量模板，暂不测序',
      value: "ZT5"
    },
    {
      label: '样品用完',
      value: "ZT6"
    },
    {
      label: '空载体,不测序',
      value: "XK1"
    },
    {
      label: '浓度低，不测序',
      value: "X1"
    },
    {
      label: '无条带，不测序',
      value: "X2"
    },
    {
      label: '未长菌，不测序',
      value: "X3"
    },
    {
      label: '两次未涨菌，实验停止',
      value: "X4"
    },
    {
      label: '客户取消',
      value: "KHQX1"
    },
    {
      label: '空管',
      value: "KG"
    },
    {
      label: '浓度低，重新接菌提质粒',
      value: "Y1"
    },
    {
      label: '无条带，重新接菌提质粒',
      value: "Y2"
    },
    {
      label: '未长菌，重新接菌提质粒',
      value: "Y3"
    },
    {
      label: '模板用完，重新接菌提质粒',
      value: "Y4"
    },
],
}


export const prt = {
  appraisalStatus: [
    {
      label: '正常',
      value: "ZC"
    },
    {
      label: '浓度低，最大量测序',
      value: "ZCM"
    },
    {
      label: '暂不测序',
      value: "ZT1"
    },
    {
      label: '片段大小不符，只切胶，暂不测序',
      value: "ZT2"
    },
    {
      label: '无目的条带，只回收主带，暂不测序',
      value: "ZT3"
    },
    {
      label: '重新纯化模板，暂不测序',
      value: "ZT4"
    },
    {
      label: '重新定量模板，暂不测序',
      value: "ZT5"
    },
    {
      label: '样品用完',
      value: "ZT6"
    },
    {
      label: '无条带，未切胶,不测序',
      value: "XE1"
    },
    {
      label: '浓度低，未切胶，不测序',
      value: "XE2"
    },
    {
      label: '浓度低，回收后无条带，不测序',
      value: "XE3"
    },
    {
      label: '样品正常，回收无条带，不测序',
      value: "XE4"
    },
    {
      label: '引物二聚体，未切胶，不测序',
      value: "XE5"
    },
    {
      label: '无主带，未切胶，不测序',
      value: "XE6"
    },
    {
      label: '客户取消',
      value: "KHQX"
    },
    {
      label: '空管',
      value: "KG"
    },
  ],
}

// 鉴定结果
export const authenticateResult = (status) => {
  let resultName = ''
  switch (status) {
    case 'NORMAL':
      resultName = '正常'
      break
    case 'NOT_SENT':
      resultName = '引物未送'
      break
    case 'MANUAL_EXPIRATION':
      resultName = '手动过期'
      break
    case 'EMPTY':
      resultName = '空管'
      break
    case 'RUN_OUT':
      resultName = '引物用完'
      break
    case 'CANCEL':
      resultName = '客户取消'
      break
  }
  return resultName
}

// 配送状态
export const sendStatus = (status, type) => {
  let statusName = ''
  switch (status) {
    case 'NEED_PICK':
      statusName = '待出库'
      break
    case 'PURCHASE':
      statusName = '待出库'
      break
    case 'SENDING':
      statusName = '配送中'
      break
    case 'FINISH':
      statusName = '已完成'
      break
    case 'CANCEL':
      statusName = '取消配送'
      break
    case 'NEED_SEND':
      statusName = '配送中'
      break
    // case 'NEED_PICK':
    //   statusName = '待捡货'
    //   break
    // case 'NEED_SEND':
    //   statusName = '待发货'
    //   break
    // case 'SENDING':
    //   statusName = type === 'sanger' ? '取样中' : '发货中'
    //   break
    // case 'FINISH':
    //   statusName = type === 'sanger' ? '取样完成' : '发货完成'
    //   break
    // case 'CANCEL':
    //   statusName = type === 'sanger' ? '取消取样' : '取消配送'
    //   break
  }
  return statusName
}

// 配送方式
export const sendType = (type) => {
  let typeName = ''
  switch (type) {
    case 'SENDER':
      typeName = '人工配送'
      break
    case 'DELIVERY':
      typeName = '快递'
      break
  }
  return typeName
}

// 返样状态
export const returnStatus = (status) => {
  let statusName = ''
  switch (status) {
    case 'NO':
      statusName = '未返样'
      break
    case 'ING':
      statusName = '返样中'
      break
    case 'OK':
      statusName = '已返样'
      break
  }
  return statusName
}

// 样品类型
export const demoType = (type) => {
  let typeName = ''
  switch (type) {
    case 'A':
      typeName = '菌液'
      break
    case 'B':
      typeName = '质粒'
      break
    case 'D':
      typeName = 'PCR已纯化'
      break
    case 'E':
      typeName = 'PCR未纯化'
      break
    case 'F':
      typeName = '沉降菌'
      break
  }
  return typeName
}

// 测通结果
export const testResult = (result) => {
  let resultName = ''
  switch (result) {
    case 'WAIT_TEST':
      resultName = '未测通'
      break
    case 'OK_TEST':
      resultName = '已测通'
      break
    case 'WALKING':
      resultName = 'walking'
      break
    case 'EMPTY_CARRIER':
      resultName = '空载体，终止实验'
      break
    case 'SIZE_DISCREPANCY':
      resultName = '已通大小不符'
      break
    case 'FAIL_TEST':
      resultName = '测不通'
      break
    case 'CANCEL':
      resultName = '取消测通'
      break
  }
  return resultName
}

// 获取查询关联客户/组长 id
export const getSearchId = (id) => {
  const memberInfo = baseMethods.getLocalObj('memberInfo')
  const courseInfo = baseMethods.getLocalObj('courseInfo')
  let customerId, teamId
  if (!isEmpty(id)) {
    if (courseInfo.headMan && id === courseInfo.headMan.id) {
      teamId = courseInfo.id
      customerId = ''
    } else {
      teamId = ''
      customerId = id
    }
  } else {
    if (courseInfo.headMan && courseInfo.headMan.id === memberInfo.id) {
      teamId = courseInfo.id
      customerId = ''
    } else {
      teamId = ''
      customerId = memberInfo.id
    }
  }
  return [customerId, teamId]
}

// 判断当前用户是不是组长
export const isHeadMan = () => {
  const memberInfo = getLocalObj('memberInfo')
  const courseInfo = getLocalObj('courseInfo')
  return courseInfo.headMan && memberInfo.id === courseInfo.headMan.id
}

// 下载重命名
export const courseDownload = (url, filename) => {
  getBlob(url, function(blob) {
    saveAs(blob, filename);
  })
}

export const getBlob = (url, cb) => {
  var xhr = new XMLHttpRequest()
  xhr.open('GET', url, true)
  xhr.responseType = 'blob'
  xhr.onload = function() {
    if (xhr.status === 200) {
      cb(xhr.response)
    }
  }
  xhr.send()
}

export const saveAs = (blob, filename) => {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename)
  } else {
    var link = document.createElement('a')
    var body = document.querySelector('body')

    link.href = window.URL.createObjectURL(blob)
    link.download = filename

    // fix Firefox
    link.style.display = 'none'
    body.appendChild(link)

    link.click()
    body.removeChild(link)

    window.URL.revokeObjectURL(link.href)
  }
}

export function qualityConverter  (
  num,
  sourceUnitName,
  targetUnitName,
  fixedDecimal
) {
  const fRate = {
    // 换算率
    ng: { ug: 0.001, mg: 0.001 * 0.001, g: 0.001 * 0.001 * 0.001, kg: 0.001 * 0.001 * 0.001 * 0.001, t: 0.001 * 0.001 * 0.001 * 0.001 * 0.001, ul: 0.001 * 0.001, ml: 0.001 * 0.001 * 0.001, L: 0.001 * 0.001 * 0.001 * 0.001 },
    ug: { ng: 1000, mg: 0.001, g: 0.001 * 0.001, kg: 0.001 * 0.001 * 0.001, t: 0.001 * 0.001 * 0.001 * 0.001, ul: 0.001, ml: 0.001 * 0.001, L: 0.001 * 0.001 * 0.001 },
    mg: { ng: 1000 * 1000, ug: 1000, g: 0.001, kg: 0.001 * 0.001, t: 0.001 * 0.001 * 0.001, ul: 1, ml: 0.001, L: 0.001 * 0.001 },
    g: { ng: 1000 * 1000*1000, ug: 1000*1000, mg:1000, kg: 0.001, t: 0.001 * 0.001, ul: 1000 , ml: 1, L: 0.001 },
    kg: { ng: 1000 * 1000 * 1000 * 1000, ug: 1000 * 1000, mg: 1000, g: 1000, t: 0.001 , ul: 1000 * 1000 , ml: 1000, L: 1 },
    t: { ng: 1000 * 1000 * 1000 * 1000 * 1000, ug: 1000 * 1000 * 1000, mg: 1000 * 1000, g: 1000 * 1000, kg: 1000, ul: 1000 * 1000 * 1000, ml: 1000 * 1000, L: 1000 },
    ml: { ng: 1000 * 1000 * 1000, ug: 1000 * 1000, mg: 1000, g: 1, kg: 0.001, t: 0.001 * 0.001, ul: 1000 , L: 0.001 },
    ul: { ng: 1000 * 1000, ug: 1000, mg: 1, g: 0.001, kg: 0.001 * 0.001, t: 0.001 * 0.001 * 0.001, ml: 0.001, L: 0.001 * 0.001 },
    L: { ng: 1000 * 1000 * 1000 * 1000, ug: 1000 * 1000, mg: 1000, g: 1000, kg: 1, t: 0.001, ul: 1000 * 1000, ml: 1000 },
  };
  let result = (num * fRate[sourceUnitName][targetUnitName]) / 1
  if (fixedDecimal) {
    result = (num * fRate[sourceUnitName][targetUnitName]).toFixed(fixedDecimal) / 1
  }
  return result
}



// WEBPACK FOOTER //
// ./src/utils/baseMethod.js